import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	searchPlaceholder: {
		id: 'jql-builder-basic.picker-loader.search-placeholder',
		defaultMessage: 'Search {fieldName}',
		description: 'Placeholder text in search input indicating that the user can search',
	},
	loadingMessageStart: {
		id: 'jql-builder-basic.picker-loader.loading-message-start',
		defaultMessage: '{fieldName}: Loading more',
		description: 'Screen Reader text indicating that more options are loading in picker',
	},
	loadingMessageEnd: {
		id: 'jql-builder-basic.picker-loader.loading-message-end',
		defaultMessage: '{fieldName}: Finished loading',
		description:
			'Screen Reader text indicating that loading of more options has finished in picker',
	},
});
export default messages;
